import { createStore } from 'vuex'
import State from './defalutState'

export default createStore({
  state: {
    State,
    asyncRouteMark:false,
    asyncMenuJsonList:[]
  },
  getters: {
  },
  mutations: {
    LOGIN_IN(state,token){
      state.State.userToken=token
    },
    LOGIN_OUT(state){
      state.State.userToken=""
      state.asyncRouteMark=false
    },
    SetAsyncRouteMark(state,bool){
      state.asyncRouteMark=bool
    },
    SetAsyncMenuJsonList(state,obj){
      state.asyncMenuJsonList=obj
    },

    setFontSize(state, fontSize) {
      state.fontSize = fontSize;
    }
  },
  actions: {
    updateFontSize({ commit }, fontSize) {
      commit('setFontSize', fontSize);
    }
  },
  modules: {
  }
})


